import LeadMagnetPage from "@/components/LeadMagnetPage";
import docShot from "@/assets/lm/posting-doc-cover-v2.png.asset.json";
import beforeAfter from "@/assets/lm/posting-doc-before-after.png.asset.json";
import aiPrompt from "@/assets/lm/posting-doc-ai-prompt.png.asset.json";
import docsLogo from "@/assets/lm/google-docs-logo.webp.asset.json";

const LmPosting = () => (
  <LeadMagnetPage c={{
    path: "/lm/posting", tag: "lm-posting", leadMagnet: "posting", eyebrow: "THE PROCEDURE",
    headline: "Fill out the form and get access to the guide now",
    subtitle: "Where to Post as a Remodeling Company (and How to Be Everywhere in No Time)",
    cover: docShot.url,
    coverAlt: "Google Doc: Where to Post as a Remodeling Company (and How to Be Everywhere in No Time)",
    coverWidth: 1271, coverHeight: 829,
    coverClassName: "mx-auto block w-full max-w-[200px] rounded-xl border border-white/10 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.8)] md:max-w-none",
    extraImages: [
      {
        src: beforeAfter.url,
        alt: "Inside the guide: the before and after of posting manually on every platform versus posting once and publishing everywhere",
        width: 1274, height: 769,
      },
      {
        src: aiPrompt.url,
        alt: "Inside the guide: the bonus AI prompt that sets everything up in one conversation",
        width: 1253, height: 755,
      },
    ],
    logo: docsLogo.url, logoAlt: "Google Docs", logoLabel: "Google Doc",
    ctaLabel: "Text me the link now",
    seoTitle: "Free Guide: Where to Post as a Remodeling Company",
    seoDescription: "Free guide for remodeling companies: which platforms to post on, what to film and how to be everywhere your homeowners scroll, in no time.",
  }} />
);

export default LmPosting;
